import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AddableCartItemKinds } from '@/api/phdApiV2Client/request.types';
import { updateDealRecipes } from '@/builders/deals/slice/userSelections.slice';
import { DealStep } from '@/builders/deals/slice/dealTypes';
import { Product } from '@/domain/product/types';

interface Props {
    dealStepData: DealStep;
    selectedDealStepItem: Product;
    dealStepIndex: number;
}

const useStepHasDefaultVariantCode = ({
    dealStepData,
    selectedDealStepItem,
    dealStepIndex
}: Props) => { 
    const dispatch = useDispatch();  

    useEffect(() => {
        if (!dealStepData?.defaultVariantCode || selectedDealStepItem?.id) return;

        dealStepData.recipeOptions.some((option) => {
            const sizes = option.displayableProduct?.sizes || [];
            const match = sizes.find((size) => size.variantCode === dealStepData.defaultVariantCode);
    
            if (match) {
                const selectedDealItem = {
                    kind: AddableCartItemKinds.PRODUCT as const,
                    quantity: 1,
                    description: option.description,
                    id: option.id,
                    name: option.name,
                    sodiumWarning: option.sodiumWarning,
                    type: option.type,
                    selectedModifiers: [
                        {
                            id: match.id,
                            name: match.name,
                            type: match.type,
                            sodiumWarning: match.sodiumWarning,
                            variantCode: match.variantCode
                        }
                    ]
                };
    
                dispatch(
                    updateDealRecipes([
                        {
                            item: selectedDealItem,
                            stepId: dealStepData.id,
                            index: dealStepIndex
                        }
                    ])
                );
                return true;
            }
            return false;
        });
    }, [dealStepData, selectedDealStepItem, dealStepIndex, dispatch]);

};

export default useStepHasDefaultVariantCode;
